window.addEventListener('load', function () {
  animateOnLoad();

  if (window.innerWidth < 1024) {
    setInterval(() => {
      animateOnLoad();
    }, 25000);
  } else {
    setInterval(() => {
      animateOnLoad();
    }, 20000);
  }
});

function animateOnLoad() {
  let section4 = document.querySelector('.section4');
  // let windowHeight = window.innerHeight;
  // let section4Top = section4.getBoundingClientRect().top;

  animateElements();
  const animEls = document.querySelectorAll('.section4__anim-el');
  animEls.forEach((el) => {
    const parent = el.parentNode;
    const clone = el.cloneNode(true);
    parent.removeChild(el);
    parent.appendChild(clone);
  });
  animateSection3();
  const animElCenters = document.querySelectorAll('.section4__anim-el-center');
  animElCenters.forEach((el) => {
    const parent = el.parentNode;
    const clone = el.cloneNode(true);
    parent.removeChild(el);
    parent.appendChild(clone);
  });
  animateSection3Mob();
  const animElsMob = document.querySelectorAll('.section4__anim-el-mob');
  animElsMob.forEach((el) => {
    const parent = el.parentNode;
    const clone = el.cloneNode(true);
    parent.removeChild(el);
    parent.appendChild(clone);
  });
  animateElementsMob();
  const animElCentersMob = document.querySelectorAll(
    '.section4__anim-el-center-mob'
  );
  animElCentersMob.forEach((el) => {
    const parent = el.parentNode;
    const clone = el.cloneNode(true);
    parent.removeChild(el);
    parent.appendChild(clone);
  });
}

// window.addEventListener('resize', function () {
//   animateOnLoad();
// });

function animateElements() {
  const animEls = document.querySelectorAll('.section4__anim-el');
  const delays = [6000, 3000, 1000];
  animEls.forEach((el, index) => {
    el.style.animationDelay = delays[index] + 'ms';
    el.style.visibility = 'visible';
    el.style.opacity = '1';
  });
}

function animateSection3() {
  const animElCenters = document.querySelectorAll('.section4__anim-el-center');
  // const delays = [10000, 6000, 4000];
  const delays = [4000, 6000, 10000];
  animElCenters.forEach((el, index) => {
    el.style.animationDelay = delays[index] + 'ms';
    el.style.visibility = 'hidden';
    el.style.opacity = '0';
  });
}

function animateElementsMob() {
  const animEls = document.querySelectorAll('.section4__anim-el-mob');
  const delay = 5000;

  animEls.forEach((el, index) => {
    el.style.animationDelay = index * delay + 'ms';
    el.style.visibility = 'visible';
    el.style.opacity = '1';

    if (index === animEls.length - 2) {
      el.style.transitionDelay = index * delay + 'ms';
      el.style.opacity = '0';
    }
    if (index === animEls.length - 1) {
      el.style.transitionDelay = index * delay + 'ms';
      el.style.opacity = '0';
    }
  });
}

function animateSection3Mob() {
  const animElCenters = document.querySelectorAll(
    '.section4__anim-el-center-mob'
  );
  const delays = [17000, 12000, 7000];
  // const delays = [7000, 12000, 17000];

  animElCenters.forEach((el, index) => {
    el.style.animationDelay = delays[index] + 'ms';
    el.style.visibility = 'hidden';
    el.style.opacity = '0';
  });
}
